import { Mail } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { useNavigate } from 'react-router-dom';
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';

interface FAQProps {
	faqItems?: Array<{
		question: string;
		answer: string;
	}>;
}

function FAQ({ faqItems = [] }: FAQProps) {
	const navigate = useNavigate();
	return (
		<div className='w-full py-20'>
			<div className='container mx-auto px-4 md:px-30'>
				<div className='grid lg:grid-cols-2 gap-10'>
					<div className='flex gap-10 flex-col items-center lg:items-start text-center lg:text-left'>
						<div className='flex gap-4 flex-col'>
							<div>
								<Badge variant='outline'>FAQ</Badge>
							</div>
							<div className='flex gap-2 flex-col'>
								<header className='max-w-full text-neutral-800 w-full lg:w-[427px]'>
									<h1 className='text-4xl font-bold leading-[40px] max-md:text-[30px] max-md:leading-[40px]'>
										Frequently <br />
										asked questions.
									</h1>
									<h2 className='mt-6 text-lg leading-snug'>
										Contact our team for more information about our services and
										how we can help you become a confident speaker.
									</h2>
								</header>
							</div>
							<div className='md:py-4'>
								<Button
									className='gap-4 bg-[#fbb040] hover:bg-amber-100 rounded-3xl text-white'
									variant='outline'
									onClick={() => navigate('/contact')}
								>
									Any questions? Reach out <Mail className='w-4 h-4' />
								</Button>
							</div>
						</div>
					</div>
					<Accordion type='single' collapsible className='w-full px-4 lg:px-10'>
						{faqItems.map((item, index) => (
							<AccordionItem key={index} value={'index-' + index}>
								<AccordionTrigger>{item.question}</AccordionTrigger>
								<AccordionContent>{item.answer}</AccordionContent>
							</AccordionItem>
						))}
					</Accordion>
				</div>
			</div>
		</div>
	);
}

export { FAQ };
